import Vue from "vue";
import Vuex, { MutationTree, ActionTree } from "vuex";
import { User } from "../../../models/user";
import axios from 'axios';

Vue.use(Vuex);

interface State {
    currentUser: User
    loggedIn: boolean
}

const mutations: MutationTree<State> = {
    setCurrentUser: (state, currentUser) => {
        state.currentUser = currentUser
    },

    setApiToken: (state, api_token) => {
        // Update the local storage by hand
        localStorage.removeItem("api_token");
        localStorage.setItem('api_token', api_token);
        axios.defaults.headers.common['Authorization'] = 'Bearer '.concat(api_token);

        state.loggedIn = true
    },

    logout: (state) => {
        state.loggedIn = false
        state.currentUser = {
            firstname: '',
            lastname: '',
            email: '',
            password: '',
            password_confirmation: '',
        }

        console.log("Reset the account currentUser and the loggedIn status")
    }
};

const actions: ActionTree < State, any > = {

};

const getters = {
    currentUser(state:State) {
        return state.currentUser
    },

    loggedIn(state:State): boolean {
        return state.loggedIn
    }
};

const state: State = {
    currentUser: {
        firstname: '',
        lastname: '',
        email: '',
        password: '',
        password_confirmation: '',
    },

    loggedIn: false
};

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default module;


// WEBPACK FOOTER //
// ./src/vuex/modules/account/store.ts